import React, { useState, useEffect } from "react";
import {
  Container,
  HamburgerIcon,
  Logo,
  Heading,
  HeaderRightContent,

} from "./styles";
import { navItems } from "components/nav";
import { useLocation, navigate } from "@reach/router";
import { Row, Col } from "components/shared/layout";
import useWindowSize from "hooks/windowSize";
import routes from "utils/absoluteRoutes";

const Mobile = (title, setOpen) => {
  return (
    <Col p="35px 0px" style={{ width: "100%" }}>
      <Row justifyContent="space-between" alignItems="center">
        <Logo
          src={require(`assets/images/zlto-logo.svg`)}
          alt="Zlto logo"
          onClick={() => navigate(routes.bizProfile)}
        />
        <Heading>{title}</Heading>
        <HamburgerIcon
          onClick={() => setOpen(true)}
          src={require("assets/images/burger.svg")}
          alt="Menu hamburger"
        />
      </Row>
    </Col>
  );
};

const Desktop = (Icon, title, headerRightContent) => {
  return (
    <Row alignItems="center">
      {Icon && <Icon />}
      <Heading>{title}</Heading>
      <HeaderRightContent>{headerRightContent}</HeaderRightContent>
    </Row>
  );
};

const Header = ({ ...props }) => {
  const location = useLocation().pathname;
  const [width] = useWindowSize();
  const [headerInfo, setHeaderInfo] = useState({});

  useEffect(() => {
    let navInfo = navItems.find((i) => location.includes(i.route));
    if (navInfo) {
      setHeaderInfo({ ...navInfo });
    }
  }, [location]);

  const Icon = headerInfo?.Icon;
  const mobile = width <= 1366;
  return (
    <Container {...props}>
      <Row alignItems="center">
        {mobile
          ? Mobile(headerInfo.title, props.setOpen, props.headerRightContent)
          : Desktop(Icon, headerInfo.title, props.headerRightContent)}
      </Row>
    </Container>
  );
};
export default Header;
